var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 9.611L22.389 8 16 14.389 9.611 8 8 9.611 14.389 16 8 22.389 9.611 24 16 17.611 22.389 24 24 22.389 17.611 16z"
  })));
};
export default __webpack_public_path__ + "static/media/close.c0cc79df.svg";
export { SvgClose as ReactComponent };